import React from 'react';
import PropTypes from 'prop-types';

const CommercialVehicleCard = ({ title, content, backgroundColor, image }) => {
    return (
        <div className="card" style={{ background: backgroundColor }}>
            <div className="card-content">
                <h2 className="card-title">{title}</h2>
                <p className="card-description">{content}</p>
                <img src={image} alt={title} className="card-image" />
            </div>
        </div>
    );
};


CommercialVehicleCard.propTypes = {
    title: PropTypes.string.isRequired,
    content: PropTypes.string.isRequired,
    backgroundColor: PropTypes.string.isRequired,
    image: PropTypes.string.isRequired,
};

export default CommercialVehicleCard;